import { render, staticRenderFns } from "./Terms-fr.vue?vue&type=template&id=a38c08e0&"
import script from "./Terms-fr.vue?vue&type=script&lang=js&"
export * from "./Terms-fr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports